const accountIntendedTransactionTypeOptions: { [key: string]: string } = {
  'Only Sending Money': 'Only Sending Money',
  'Only Collecting Money': 'Only Collecting Money',
  'Sending and Collecting Money': 'Sending and Collecting Money',
};

export default accountIntendedTransactionTypeOptions;
